/* eslint-disable */
import { AfterViewInit, Component, ViewChild } from '@angular/core';
import {
  FormEditFieldCreateDialogView,
  FormEditFieldDialogContext,
  FormEditFieldUpdateDialogView,
  FormGroupModel,
  FormModel
} from '../../../../../../../util/form/form-utils';
import {
  FieldValidationError,
  FormRef,
  LocalFieldValidationErrors,
  LocalFieldValidationErrorsFactory
} from '../../../../../../../lib/util/services';
import { Form } from '../../../../../../../lib/form/form.service';
import { InputMask } from '../../../../../../../util/input-masks';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { NgModel } from '@angular/forms';
import { FieldWidthType } from '../../../../../../../util/form/form-field-width-type';
import {
  FieldValidationType,
  FormFieldValidationTypeModel
} from '../../../../../../../util/form/form-field-validation-type';
import { List } from 'immutable';
import { OptionItem, TypeItem, UiConstants } from '../../../../../../../util/core-utils';
import { DocumentFileService } from '../../../../../../../lib/document/document-file.service';
import { ToasterService } from '../../../../../../../fork/angular2-toaster/angular2-toaster';
import { StringKey } from '../../../../../../../app.string-keys';
import { TranslateService } from '@ngx-translate/core';
import { Models } from '../../../../../../../util/model-utils';
import { Angular2Multiselects } from '../../../../../../../util/multiselect';
import { Strings } from '../../../../../../../lib/util/strings';

/* eslint-enable */

@Component({
  selector: 'app-form-edit-create-update-readonly-picture-field-dialog',
  templateUrl: './form-edit-create-update-readonly-picture-field-dialog.component.html',
  styleUrls: ['./form-edit-create-update-readonly-picture-field-dialog.component.scss']
})
export class FormEditCreateUpdateReadonlyPictureFieldDialogComponent
  implements FormEditFieldCreateDialogView, FormEditFieldUpdateDialogView, FormRef, AfterViewInit {

  public readonly selector = Form.FieldDataTypeSelector.READONLY_PICTURE;
  public readonly createTitle = 'FORM_ITEM_CREATE_READONLY_PICTURE_TITLE';
  public readonly updateTitle = 'FORM_ITEM_UPDATE_READONLY_PICTURE_TITLE';
  public readonly cloneTitle = 'FORM_ITEM_CLONE_READONLY_PICTURE_TITLE';

  InputMask = InputMask;
  Form = Form;
  UiConstants = UiConstants;

  @ViewChild('fieldDialog', { static: true })
  dialogComponent: ModalDirective;

  @ViewChild('title')
  titleInput: NgModel;

  @ViewChild('api_export_name')
  apiExportNameInput: NgModel;

  @ViewChild('file_document')
  fileDocumentInput: NgModel;

  visible: boolean = false;
  fieldModel: Model = new Model();
  dialogTitleDictionaryKey: string = '';
  latestApiExportName = '';

  fieldWidthTypes: FieldWidthType[] = FieldWidthType.VALUES.toArray();
  fieldValidationTypes: Form.FormFieldValidationType[] = FieldValidationType.VALUES.toArray();

  private fieldErrors: FieldValidationError<Form.FieldValidatedField> =
    FieldValidationError.empty<Form.FieldValidatedField>();

  private validatedInputs: LocalFieldValidationErrors<NgModel> =
    LocalFieldValidationErrorsFactory.empty();

  private context: FormEditFieldDialogContext;
  private group: FormGroupModel;
  private field?: Form.Field;
  private clone?: boolean;
  private submitted: boolean = false;

  availableFileDocuments: TypeItem[] = [];

  dropdownSettings?: Angular2Multiselects.Settings;

  getForm() {
    return {
      submitted: this.submitted
    };
  }

  public constructor(private documentFileService: DocumentFileService,
                     private toasterService: ToasterService,
                     private translateService: TranslateService) {
  }

  ngAfterViewInit(): void {
    this.loadLocalFieldValidationErrors();
    this.initDropdownSettings();
  }

  initDropdownSettings() {
    this.dropdownSettings = new Angular2Multiselects.SettingsBuilder()
      .singleSelection(true)
      .enableSearchFilter(true)
      .enableCheckAll(false)
      .remoteSearch(true)
      .labelKey(OptionItem.KEY_TEXT)
      .build();
  }

    registerContext(context: FormEditFieldDialogContext): void {
    this.context = context;
  }

  showDialog(form: FormModel, group: FormGroupModel, field?: Form.Field, clone?: boolean): void {
    this.latestApiExportName = '';
    this.visible = true;
    this.clone = clone;
    this.loadFileDocumentsAndShowDialog(form, group, field, clone);
  }

  onModalHide(event: ModalDirective) {
    if (event.dismissReason === 'backdrop-click' || event.dismissReason === 'esc') {
      this.visible = false;
      this.submitted = false;
      this.fieldModel = new Model();
    }
  }

  closeDialog(): void {
    this.visible = false;
    this.submitted = false;
    this.dialogComponent.hide();
    this.fieldModel = new Model();
  }

  saveField() {
    this.submitted = true;
    if (this.hasLocalFieldError(this.titleInput)
      || this.hasLocalFieldError(this.apiExportNameInput)
      || this.hasLocalFieldError(this.fileDocumentInput)) {
      return;
    }
    if (this.field && this.clone) {
      this.createField();
    }
    else if (this.field) {
      this.updateField(this.field);
    }
    else {
      this.createField();
    }
  }

  hasLocalFieldError(field?: NgModel): boolean {
    return this.validatedInputs.hasLocalError(field);
  }

  hasFieldError(field?: Form.FieldValidatedField): boolean {
    return this.fieldErrors.hasError(field);
  }

  removeFieldError(field: Form.FieldValidatedField) {
    this.fieldErrors = this.fieldErrors.removeError(field);
  }

  getFieldErrorText(field: Form.FieldValidatedField): string {
    return this.fieldErrors.getErrorText(field);
  }

  getFieldValidationTypeDictionaryKey(vt: Form.FormFieldValidationType): string {
    return FieldValidationType.getFieldValidationTypeDictionaryKey(vt);
  }

  onAdminFormFieldValidationTypeChanged() {
    FieldValidationType.onAdminFormFieldValidationTypeChanged(this.fieldModel);
  }

  onMobileFormFieldValidationTypeChanged() {
    FieldValidationType.onMobileFormFieldValidationTypeChanged(this.fieldModel);
  }

  private loadLocalFieldValidationErrors() {
    const validatedInputs = List.of(this.titleInput, this.apiExportNameInput);
    this.validatedInputs = LocalFieldValidationErrorsFactory.ofFields(this, validatedInputs);
  }

  private loadFileDocumentsAndShowDialog(form: FormModel, group: FormGroupModel, field?: Form.Field, clone?: boolean) {
    this.loadFileDocuments(() => {
      if (this.availableFileDocuments.length > 0) {
        this.loadDialog(form, group, field, clone);
      }
      else {
        this.toasterService.pop({
          timeout: UiConstants.ToastTimeoutLong,
          type: UiConstants.toastTypeError,
          title: this.translateService.instant(StringKey.FORM_ITEM_READONLY_PICTURE_NO_IMAGE_TITLE),
          body: this.translateService.instant(StringKey.FORM_ITEM_READONLY_PICTURE_NO_IMAGE_MESSAGE)
        });
      }
    });
  }

  private loadFileDocuments(completion: () => void, searchValue?: string) {
    this.documentFileService.query({
      name: Strings.undefinedOrNonEmpty(searchValue),
      content_type: 'image',
      disabled: false,
      number_of_items: UiConstants.autocompletePageSize,
      page_number: 1,
      no_progress_bar: true
    }).subscribe(documentFileList => {
      this.availableFileDocuments = [];
      documentFileList.items.forEach((documentFile) => {
        if (documentFile) {
          const item = new TypeItem();
          item.id = documentFile.id;
          item.text = documentFile.name;
          item.disabled = documentFile.disabled;
          this.availableFileDocuments.push(item);
        }
      });
      if (completion) {
        completion();
      }
    });
  }

  private loadDialog(form: FormModel, group: FormGroupModel, field?: Form.Field, clone?: boolean) {
    this.group = group;
    this.dialogComponent.show();
    if (field && clone) {
      this.dialogTitleDictionaryKey = this.cloneTitle;
      this.loadField(field);
    }
    else if (field) {
      this.dialogTitleDictionaryKey = this.updateTitle;
      this.loadField(field);
    }
    else {
      this.dialogTitleDictionaryKey = this.createTitle;
    }
  }

  private loadField(field: Form.Field) {
    this.field = field;
    const attrs = field.dataType.readonlyPictureAttributes!;
    const fieldWidth = FieldWidthType.fromPercentValue(field.formFieldWidthPercent);
    this.fieldModel.title = field.title;
    this.fieldModel.description = field.description ? field.description : '';
    this.fieldModel.apiExportName = field.apiExportName ? field.apiExportName : '';
    this.fieldModel.pdfExportName = field.pdfExportName ? field.pdfExportName : '';
    this.fieldModel.displayOnNewRow = field.displayOnNewRow;
    this.fieldModel.fieldWidthType = fieldWidth ? fieldWidth : FieldWidthType.FULL_SCREEN;
    this.fieldModel.adminFormFieldValidationType = field.admin.validationType;
    this.fieldModel.helpdeskFormFieldValidationType = field.helpdesk.validationType;
    this.fieldModel.mobileFormFieldValidationType = field.mobile.validationType;
    this.setFileDocumentItem(attrs.value);
  }

  private createField() {
    this.context.formService.createField({
      parentId: this.context.parentId,
      groupId: this.group.groupId,
      title: this.fieldModel.title,
      description: this.fieldModel.description,
      pdfExportName: this.fieldModel.pdfExportName,
      apiExportName: this.fieldModel.apiExportName,
      dataTypeSelector: this.selector,
      dataType: this.getDataTypeRequest(),
      formFieldWidthPercent: this.fieldModel.fieldWidthType.percentValue,
      admin: {
        visibleOnFormDetail: this.fieldModel.adminVisibleOnFormDetail,
        validationType: this.fieldModel.adminFormFieldValidationType
      },
      helpdesk: {
        validationType: this.fieldModel.helpdeskFormFieldValidationType
      },
      mobile: {
        visibleOnFormDetail: this.fieldModel.mobileVisibleOnFormDetail,
        visibleOnMasterDetail: this.fieldModel.mobileVisibleOnMasterDetail,
        validationType: this.fieldModel.mobileFormFieldValidationType
      },
      displayOnNewRow: this.fieldModel.displayOnNewRow
    }).subscribe(
      (result) => {
        this.context.formView.reloadForm();
        this.closeDialog();
      },
      (error) => {
        if (error instanceof FieldValidationError) {
          this.fieldErrors = error.withFormRef(this);
        }
      }
    );
  }

  private updateField(field: Form.Field) {
    this.context.formService.updateField({
      parentId: this.context.parentId,
      groupId: this.group.groupId,
      fieldId: field.fieldId,
      title: this.fieldModel.title,
      description: this.fieldModel.description,
      pdfExportName: this.fieldModel.pdfExportName,
      apiExportName: this.fieldModel.apiExportName,
      dataTypeSelector: this.selector,
      dataType: this.getDataTypeRequest(),
      formFieldWidthPercent: this.fieldModel.fieldWidthType.percentValue,
      admin: {
        visibleOnFormDetail: this.fieldModel.adminVisibleOnFormDetail,
        validationType: this.fieldModel.adminFormFieldValidationType
      },
      helpdesk: {
        validationType: this.fieldModel.helpdeskFormFieldValidationType
      },
      mobile: {
        visibleOnFormDetail: this.fieldModel.mobileVisibleOnFormDetail,
        visibleOnMasterDetail: this.fieldModel.mobileVisibleOnMasterDetail,
        validationType: this.fieldModel.mobileFormFieldValidationType
      },
      displayOnNewRow: this.fieldModel.displayOnNewRow
    }).subscribe(
      (result) => {
        this.context.formView.reloadForm();
        this.closeDialog();
      },
      (error) => {
        if (error instanceof FieldValidationError) {
          this.fieldErrors = error.withFormRef(this);
        }
      }
    );
  }

  private getDataTypeRequest(): Form.FieldDataType {
    return {
      readonlyPictureAttributes: {
        value: this.fieldModel.fileDocumentItem[0].id!,
      }
    };
  }

  setFileDocumentItem(fileDocumentId: number) {
    this.fieldModel.fileDocumentItem = [];
    this.availableFileDocuments.forEach( (fileDocument) => {
      if (fileDocument.id === fileDocumentId) {
        this.fieldModel.fileDocumentItem.push(fileDocument)
      }
    });
    if (this.fieldModel.fileDocumentItem.length === 0) {
      this.documentFileService.query({
        id: fileDocumentId.toString()
      }).subscribe(documentFileList => {
        this.fieldModel.fileDocumentItem = [];
        documentFileList.items.forEach((documentFile) => {
          if (documentFile) {
            const item = new TypeItem();
            item.id = documentFile.id;
            item.text = documentFile.name;
            item.disabled = documentFile.disabled;
            this.fieldModel.fileDocumentItem.push(item);
          }
        });
      });
    }
  }

  onTitleBlur() {
    const normalizedText = Models.normalizeText(this.fieldModel.title);
    if (this.fieldModel.apiExportName === '') {
      this.fieldModel.apiExportName = normalizedText;
    }
    if (this.fieldModel.pdfExportName === '') {
      this.fieldModel.pdfExportName = normalizedText;
    }
  }
}

export class Model implements FormFieldValidationTypeModel {
  title: string = '';
  description: string = '';
  apiExportName: string = '';
  pdfExportName: string = '';
  displayOnNewRow: boolean = true;
  fieldWidthType: FieldWidthType = FieldWidthType.DEFAULT;
  adminVisibleOnFormDetail: boolean = true;
  mobileVisibleOnFormDetail: boolean = true;
  mobileVisibleOnMasterDetail: boolean = false;
  adminFormFieldValidationType: Form.FormFieldValidationType = Form.FormFieldValidationType.OPTIONAL;
  helpdeskFormFieldValidationType: Form.FormFieldValidationType = Form.FormFieldValidationType.OPTIONAL;
  mobileFormFieldValidationType: Form.FormFieldValidationType = Form.FormFieldValidationType.OPTIONAL;
  multiSelect: boolean = false;
  fileDocumentItem: TypeItem[] = [];
}
